<template>
  <div class="container" v-loading="loading"></div>
</template>

<script>
import baseUrl from '@/requests/url.js'
export default {
  data() {
    return {
      token: '',
      baseUrl: baseUrl.fileUrl,
      loading: true,
    }
  },

  created() {
    this.toLogin()
  },
  methods: {
    toLogin() {
      this.$http({
        url: '/api/v1/user/nologin',
        method: 'GET',
      }).then((res) => {
        localStorage.setItem('token', res.returnvalue.token)
        localStorage.setItem('customerCode', res.returnvalue.customerCode)
        localStorage.setItem('customercode', res.returnvalue.customerCode)
        localStorage.setItem('userruid', res.returnvalue.userRuid)
        localStorage.setItem('supper', res.returnvalue.supper)
        this.loading = false
        setTimeout(() => {
          this.$router.replace({
            path: '/',
          })
        }, 800)
      })
    },
    mounted() {},
  },
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  width: 100%;
}
</style>
